// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"goTop_root__c8RqV","scrollTop":"goTop_scrollTop__DPYWk"};